import React from "react";
import TablaClienteRetail from "js/components/TablaClienteRetail";

function ClienteRetail(props) {
  return <TablaClienteRetail />;
}

export default ClienteRetail;
